"use client"
// import { Button } from "@workspace/web-ui/components/button"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@workspace/web-ui/components/accordion";
import { ChevronDown } from "lucide-react";
import supportBlobImage from "~/assets/support_Blob.png";

 
export const faqs = [
  {
    id: "1",
    title: "How do I resume my treatment chat with Alfie?",
    content:
      "Go to your Home tab and look for <b>Resume Chat</b> in your To-Do section. Tap it to continue where you left off.",
  },
  {
    id: "2",
    title: "I can't complete my payment. What should I do?",
    content:
      "Check your payment method and ensure it's valid. If issues persist, contact our support team for assistance.",
  },
  {
    id: "3",
    title: "What if my symptoms aren't covered by ProxyMedicine?",
    content:
      "Alfie will let you know if your symptoms require in-person medical attention and recommend seeing a healthcare professional.",
  },
  {
    id: "4",
    title: "How soon can I expect to see results?",
    content:
      "Results vary depending on individual factors like adherence to the plan, starting weight, and metabolism. Many customers report noticeable progress within the first month.",
  },
  {
    id: "5",
    title: "Is my health information secure?",
    content:
      "Yes, all health data is encrypted and HIPAA compliant. Your privacy and security are our top priorities.",
  },
];

  export default function SupportPage() {

  return (
    <main className="flex w-full flex-col pb-20 gap-6">
      <section className="py-10">
         {/* Subnav one */}
        <div  className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
            <div>      
                <h1 className="lg:text-[40px] text-[24px] font-bold lg:leading-[140%] tracking-[-2%] text-[#1A202C]">Support</h1>
                <p className="text-[#464B55] text-[14px] lg:leading-[140%] tracking-[-1%] font-normal">Get assistance and support here</p>
            </div>
        </div>
{/* banner section


          style={{
            background: "linear-gradient(90deg, rgba(255, 235, 235, 0) 0%, #FFEBEB 50%, rgba(255, 235, 235, 0) 100%);",
            backgroundImage: `url(${supportBlobImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundBlendMode: 'overlay',
            backgroundRepeat: 'no-repeat'
          }} 
*/}
 
        <div 
                  style={{
            background: "linear-gradient(90deg, rgba(255, 235, 235, 0) 0%, #FFEBEB 50%, rgba(255, 235, 235, 0) 100%);",
            backgroundImage: `url(${supportBlobImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundBlendMode: 'overlay',
            backgroundRepeat: 'no-repeat',
           }} 

          className="flex flex-col gap-[8px] bg-[#ffffff9d] justify-center text-center items-center mb-6 py-[16px]"
        >
            <h1 className="text-[#000000] lg:text-[24px] text-[18px] font-medium leading-[130%] tracking-[-2%]">🚨 Medical Emergency 🚨 </h1>
            <p className="text-[#464B55] lg:text-[16px] text-[12px] leading-[140%] tracking-[-1%] font-normal">If you're experiencing a medical emergency, please call <b>911</b>  or go to your nearest emergency room immediately.</p>       
        </div>
        {/* email support section */}
        <div className="flex flex-col items-center bg-[#EAF2FF] border-[#0404040D] border-[1px] p-[24px] gap-[24px] mx-auto lg:w-[65%] w-full rounded-[12px] flex flex-col text-center">  
            <div className="flex justify-center items-center text-center gap-[16px] flex-col">
                <span className="text-[#1A202C] text-[104px] leading-[104px] font-medium">✉️</span>
                <h1 className="text-[#1A202C] lg:text-[24px] text-[18px] font-medium leading-[130%] tracking-[-2%]">Email Support</h1>
                <p className="text-[#464B55] lg:text-[14px] text-[12px] leading-[140%] tracking-[-1%] font-normal">Send us a detailed message about your issue and we'll get back to you within 24 hours. Please include your account email and describe your problem in detail.</p>
            </div>
            <a href="mailto:appointments@proxymedicine.com" 
            style={{boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.1)"}}  
            className=  "lg:w-[60%] bg-primary text-primary-foreground shadow hover:bg-primary/90 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[8px] text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border-[#DCDCDE] h-auto text-[#fff] lg:text-[16px] text-[12px] w-full !py-[12px] !px-[16px]" >
                appointments@proxymedicine.com 
            </a>
        </div>
        {/* frequently asked questions section */}
        <div className="flex flex-col mt-20 gap-[24px] lg:w-[65%] w-full mx-auto">
            <h1 className="text-[#1A202C] lg:text-[24px] text-[18px] font-medium leading-[130%] text-center tracking-[-2%]">Frequently Asked Questions</h1>
            <div className="flex flex-col gap-[16px]">
      <Accordion type="single" collapsible             className=" w-full rounded-xl overflow-hidden border-[1px] border-solid border-[#2222221A] bg-white !p-0  font-paragraph shadow-[0px_0px_1px_0px_rgba(0,0,0,0.1),0px_2px_2px_0px_rgba(0,0,0,0.09),0px_4px_2px_0px_rgba(0,0,0,0.05),0px_7px_3px_0px_rgba(0,0,0,0.01),0px_10px_3px_0px_rgba(0,0,0,0)] sm:mb-[2%] sm:px-[2%] sm:py-[3%]"
>
        {faqs.map((item) => (
          <AccordionItem
            value={item.id}
            key={item.id}
            className=" w-full !mb-0  bg-white px-4 py-0 font-paragraph !border-b sm:mb-[2%] sm:px-[2%] sm:py-[3%]"
          >
            <AccordionTrigger showChevron={false} className="flex flex-1 items-center justify-between py-2 text-left text-[15px] text-base font-bold leading-6 text-[#4F4D55] transition-all [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0 [&[data-state=open]>svg]:rotate-180">
              <p className="lg:text-xl text-[14px] font-medium capitalize text-[#1A202C]">
                {item.title}
              </p>

              <ChevronDown
                size={40}
                strokeWidth={1.5}
                className="shrink-0 rounded-[555px] bg-[#F2F2F2] p-2 opacity-60 transition-transform duration-200"
                aria-hidden="true"
              />
            </AccordionTrigger>
            <AccordionContent className="pb-2 lg:text-sm text-[12px] font-normal text-[#464B55] sm:text-base md:text-lg">
              {item.content}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
            </div>
        </div>
      </section>

      {/* Chatbot using Sheet component */}
      {/* <AlfieChatBot open={showChatBot} onOpenChange={setShowChatBot} initialMessage={initialChatMessage} initialThreadId={initialThreadId} /> */}
    </main>
  )

}
